import { useNavigate } from 'react-router-dom';
import { GridColDef, GridRowsProp } from '@mui/x-data-grid';
import IGridComponent from '../../../components/grid/i-grid.component';
import { useContext, useEffect, useState } from 'react';
import { AppContext } from '../../../app-context';
import TitlePanel from '../../../components/title-panel/title-panel.component';
import { getMasterDataById } from '../../master-data/masterdata.services';
import { getAllPojoChallan } from '../order.services';
import IDialogComponent from '../../../components/dialog/i-dialog.component';
import SpecsComponent from '../../master-data/specs/specs.component';
import { isEmpty, isNotEmpty } from '../../common/util.services';
import { ALL, GET_ALL_SUPPLIER_URL, PAGE_SIZE } from '../../common/constants';
import { Stack } from '@mui/system';
import { Grid, IconButton } from '@mui/material';
import { HelpOutline } from '@mui/icons-material';
import { getEnquiryProduct } from '../../enquiry/enquiry.services';
import ProductDetailComponent from '../../enquiry/enq-product/product-detail.component';
import SearchPanel from '../../../components/search-panel/search-panel.component';
import ITextField from '../../../components/text-component/textfield/i-textfield.component';
import IDropdown from '../../../components/text-component/dropdown/i-dropdown.component';

const PojoChallanComponent = (props: any) => {
  const navigate = useNavigate();
  const appContext = useContext(AppContext);
  const rows: GridRowsProp = [];
  const [pojoChallanData, setPojoChallanData] = useState(rows); 
  const [loading, setLoading] = useState(true);
  const [specsData, setSpecsData] = useState(null);
  const [openSpecs, setOpenSpecs] = useState(false);
  const [openPrdDetail, setOpenPrdDetail] = useState(false);
  const [prdDetail, setPrdDetail] = useState(null);
  const [page, setPage] = useState(0);
  const [pageSize, setPageSize] = useState(PAGE_SIZE);
  const [totalRows, setTotalRows] = useState(0);
  const [searchData, setSearchData] = useState<any>({searchText: '', supplier: ALL, pojoType: ALL, challanType: ALL});
  const columns: GridColDef[] = [
    { field: 'orderCode', headerName: 'Order', filterable: false, sortable: false, editable: false, width: 125,
      renderCell: (params) => { return <div className="cell-link"
      onClick={() => { openBom(params.row) }}> {params.row.orderCode}</div> }
    },
    { field: 'product', headerName: 'Product', filterable: false, sortable: false, editable: false, width: 125,
      renderCell: (params) => (<Stack direction="row" alignItems="center" gap={0}>
                                <IconButton size="small" onClick={() => openPrdDetailPage(params.row.productId)}
                                  sx={{ p: 0.6, ml: -1 }}> <HelpOutline fontSize="small" color='secondary'/>
                                </IconButton>{params.row.product}</Stack>)
    },
    { field: 'customer', headerName: 'Customer', filterable: false, sortable: false, editable: false, width: 160},
    { field: 'enquiryCode', headerName: 'Enquiry', filterable: false, sortable: false, editable: false, width: 125},
    { field: 'pojoCode', headerName: 'PO/JS', filterable: false, sortable: false, editable: false, width: 110,
      renderCell: (params) => { return <div className={isEmpty(params.row.pojoCode) || 'NA' === params.row.pojoCode ? "" : "cell-link"}
      onClick={() => { openPojoPage(params.row) }}> {isEmpty(params.row.pojoCode) ? 'NA' : params.row.pojoCode}</div> }},
    { field: 'inputCode', headerName: 'I/P Code', filterable: false, sortable: false, editable: false, width: 80,
      renderCell: (params) => { return <div className={isEmpty(params.row.inputCode) ? "" : "cell-link"}
      onClick={() => { openSpecsPopup(params.row.inputCode, params.row.inputId) }}>
                      {isEmpty(params.row.inputCode) ? 'NA' : params.row.inputCode}</div>}},
    { field: 'supplier', headerName: 'Supplier', filterable: false, sortable: false, editable: false, width: 160,
      renderCell: (params) => { return isEmpty(params.row.supplier) ? 'NA' : params.row.supplier}},
    { field: 'challanCode', headerName: 'Challan', filterable: false, sortable: false, editable: false, width: 125,
      renderCell: (params) => { return <div className={isEmpty(params.row.challanCode) || 'NA' === params.row.challanCode ? "" : "cell-link"}
      onClick={() => { openChallanPage(params.row) }}> {isEmpty(params.row.challanCode) ? 'NA' : params.row.challanCode}</div> }
    },
    { field: 'challanType', headerName: 'Challan Type', filterable: false, sortable: false, editable: false, width: 125,
      renderCell: (params) => { return isEmpty(params.row.challanType) ? 'NA' : params.row.challanType}},
    { field: 'outputDesc', headerName: 'O/P Description', filterable: false, sortable: false, editable: false, width: 220,
      renderCell: (params) => { return isEmpty(params.row.outputDesc) ? 'NA' : params.row.outputDesc}}
  ];

  const openPojoPage = (row: any) => {
    if('NA' !== row.pojoCode && isNotEmpty(row.pojoCode)) {
      navigate('/order/pojo/list/' + row.linkId);
    }
  }

  const openChallanPage = (row: any) => {
    if('NA' !== row.challanCode && isNotEmpty(row.challanCode)) {
      if(0 === row.pojoId) {
        navigate('/order/challan/list/0', {state: {orderId: row.orderId, productId: row.productId, linkId: row.linkId}});
      } else {
        navigate('/order/challan/list/' + row.pojoId);
      }
    }
  }

  const openBom = (row: any) => {
    navigate('/order/processing/' + row.orderId);
  }

  const openSpecsPopup = (inputCode: any, inputId: any) => {
    if('NA' !== inputCode && isNotEmpty(inputCode)) {
      setLoading(true);
      getMasterDataById(inputId, appContext,
        (response: any) => {
          appContext.setShowLoader(false);
          setLoading(false);
          setSpecsData(response.data);
          setOpenSpecs(true);
        }, (error: any) => {
          console.log(error);
          appContext.setShowLoader(false);
          appContext.setErrorMessage(error.message);
          setLoading(false);
        });
    }
  };

  const closePrdDetail = () => {
    setOpenPrdDetail(false);
  }

  const openPrdDetailPage = (prdId: string) => {
    getEnquiryProduct(prdId, appContext,
      (response: any) => {
        appContext.setShowLoader(false);
        setPrdDetail(response.data);
        setOpenPrdDetail(true);
      }, (error: any) => {
        console.log(error);
        appContext.setShowLoader(false);
        appContext.setErrorMessage(error.message);
      });
  }

  const closeSpecs = () => {
    setOpenSpecs(false);
  }

  useEffect(() => {
    getAllPojoChallan(searchData, page, pageSize, appContext,
      (response: any) => {
        setPojoChallanData(response.data.content);
        setTotalRows(response.data.totalElements);
        appContext.setShowLoader(false);
        setLoading(false);
      }, (error: any) => {
        console.log(error);
        appContext.setShowLoader(false);
        setLoading(false);
      });
  }, [searchData, page, pageSize]);

  const search = (data: any) => {
    setSearchData(data);
  }

  const onPaginationModelChange = (evt: any) => {
    setPage(evt.page);
    setPageSize(evt.pageSize);
  }

  const getSearchComponent = () => {
    return <SearchPanel search={search} formData={searchData}>
      <Grid container spacing={1} alignItems="center">
        <Grid xs={3}>
          <ITextField name='searchText' label='Search Text' />
        </Grid>
        <Grid xs={3}>
          <IDropdown name='supplier' label='Supplier' url={GET_ALL_SUPPLIER_URL} allItemRequired={true}/>
        </Grid>
        <Grid xs={3}>
          <IDropdown name='pojoType' label='PO/JS Type' itemList={['Job Sheet', 'Purchase Order']} allItemRequired={true} />
        </Grid>
        <Grid xs={3}>
          <IDropdown name='challanType' label='Challan Type' allItemRequired={true}
            itemList={['Goods Receipt', 'Material Issue', 'Material Receipt', 'Sale Issue', 'Sale Return', 'JO Return',
                       'Disposal', 'Process Loss', 'General Account', 'Sampling Account', 'PO Return'].sort()}  />
        </Grid>
      </Grid></SearchPanel>
  }
  
  const getMainPanel = () => {
    return <>
      {getSearchComponent()}
      <IGridComponent title={''} rows={pojoChallanData} columns={columns} loading={loading} maxHeight={550}
        paginationType="server" paginationModelChange={onPaginationModelChange} totalRows={totalRows}
        showAddBtn={false} getRowId={(row: any) => row.rowId} />
      <IDialogComponent onClose={closeSpecs} open={openSpecs} title='Specifications' dialogClass={'spec-panel'} 
        dialogBody={<SpecsComponent data={specsData} />} />
      <IDialogComponent onClose={closePrdDetail} open={openPrdDetail} title={'Product Details'}
        dialogBody={<ProductDetailComponent readOnly={true} data={prdDetail} close={closePrdDetail}/>} />
    </>
  }

  return <TitlePanel title={'PO/JS/Challan'} panelBody={getMainPanel()} />
}

export default PojoChallanComponent;